import type { SelectHTMLAttributes } from "react";

import { cn } from "../../lib/cn";

type SelectOption = {
	value: string;
	label: string;
};

type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
	label?: string;
	error?: string;
	options: SelectOption[];
	placeholder?: string;
};

export function Select({
	label,
	error,
	options,
	placeholder,
	className,
	id,
	...props
}: SelectProps) {
	const selectId = id ?? (label ? label.toLowerCase().replace(/\s+/g, "-") : undefined);

	return (
		<div className="flex flex-col gap-1.5">
			{label && (
				<label htmlFor={selectId} className="text-sm font-medium text-pastel-black">
					{label}
				</label>
			)}
			<select
				id={selectId}
				className={cn(
					"w-full rounded-lg border bg-white px-3 py-2 text-sm text-pastel-black",
					"focus:outline-none focus:ring-2 focus:ring-pastel-vibrant-blue/40 focus:border-pastel-vibrant-blue",
					"transition-colors",
					error ? "border-red-400" : "border-pastel-border",
					className
				)}
				{...props}
			>
				{placeholder && (
					<option value="" disabled>
						{placeholder}
					</option>
				)}
				{options.map((option) => (
					<option key={option.value} value={option.value}>
						{option.label}
					</option>
				))}
			</select>
			{error && <p className="text-xs text-red-500">{error}</p>}
		</div>
	);
}
